import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ThemeContext = createContext({ theme: "dark", toggle: () => {} });

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState(() => {
        if (typeof window === "undefined") return "dark";
        return localStorage.getItem("unveiled-theme") || "dark";
    });

    useEffect(() => {
        const root = document.documentElement;
        if (theme === "dark") root.classList.add("dark");
        else root.classList.remove("dark");
        localStorage.setItem("unveiled-theme", theme);
        // Best-effort persist to account if logged in.
        api.post("/user/preferences", { theme }).catch(() => {});
    }, [theme]);

    // On mount, prefer server-stored theme for logged-in users.
    useEffect(() => {
        api.get("/auth/me")
            .then(({ data }) => {
                if (data?.theme && data.theme !== theme) {
                    setTheme(data.theme);
                }
            })
            .catch(() => {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));

    return (
        <ThemeContext.Provider value={{ theme, toggle }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
